// extracted by mini-css-extract-plugin
export default {"presentation":"Presentation_presentation__WKoTe"};